// Social media platform detection — used to filter drawer link sections
// to social-only. Streaming (Spotify, Apple Music), music databases
// (JamBase, MusicBrainz, setlist.fm), ticketing, and official sites are excluded.

const SOCIAL_DOMAINS = [
  'facebook.com',
  'fb.com',
  'twitter.com',
  'x.com',
  'instagram.com',
  'tiktok.com',
  'youtube.com',
  'youtu.be',
  'snapchat.com',
  'pinterest.com',
  'linkedin.com',
  'threads.net',
  'bsky.app',
  'bluesky.social',
  'reddit.com',
  'tumblr.com',
  'mastodon.social',
];

export function isSocialUrl(url) {
  if (!url) return false;
  try {
    const h = new URL(url).hostname.replace(/^www\./, '').toLowerCase();
    return SOCIAL_DOMAINS.some((d) => h === d || h.endsWith('.' + d));
  } catch {
    return false;
  }
}

const SOCIAL_IDS = new Set([
  'facebook',
  'twitter',
  'x',
  'instagram',
  'tiktok',
  'youtube',
  'snapchat',
  'pinterest',
  'linkedin',
  'threads',
  'bluesky',
  'bsky',
  'reddit',
  'tumblr',
  'mastodon',
]);

export function isSocialId(id) {
  if (!id) return false;
  return SOCIAL_IDS.has(id.toLowerCase().trim());
}
